import { PAYMENTS_FEE_CONST } from '@belong/common';

export const PAY_AS_YOU_GO_STRINGS = {
  methodStep: {
    title: 'How would you like to pay the {upfront}\u00a0upfront?',
    subtitle:
      "We'll charge the remaining {remaining} to this same payment method as each task is\u00a0completed.",
    achLabel: 'eCheck ACH',
    achDetail: `(${PAYMENTS_FEE_CONST.ACH_FEE} • 3-5 business\u00a0days)`,
    creditCardLabel: 'Credit Card',
    creditCardDetail: `(${PAYMENTS_FEE_CONST.CREDIT_CARD_FEE} Fee • Instant)`,
    cardFeeNote:
      'With Pay As You Go, the credit card fee applies to each task\u00a0charge.',
    internationalFeeNote:
      'Additional fees may apply for credit cards issued outside the\u00a0US.',
    cta: 'Done',
  },
  confirmStep: {
    title: 'Confirm your upfront\u00a0payment',
    subtitle:
      "We'll charge 20% now to get your improvements started. The rest is charged task by task as your Pros complete the\u00a0work.",
    dueNowTitle: 'Due Now',
    upfrontLabel: '20% Upfront Payment',
    cardFeeLabel: `Card Fee (${PAYMENTS_FEE_CONST.CREDIT_CARD_FEE})`,
    totalDueNowLabel: 'Total Due Now',
    perTaskTitle: 'As Each Task Is Completed',
    remainingLabel: 'Remaining balance',
    neverExceedNote:
      'This is the rest of your {total} Never Exceed total for your approved\u00a0improvements.',
    cardFeeNote: `The ${PAYMENTS_FEE_CONST.CREDIT_CARD_FEE} card fee applies to each task\u00a0charge.`,
    paymentMethodTitle: 'Payment Method',
    change: 'Change',
    cta: 'Pay {amount}',
  },
  submittingText: 'Processing your\u00a0payment\u2026',
  unconfirmedNote:
    "We're still confirming your payment. Please refresh in a few minutes before trying\u00a0again.",
  processingStep: {
    title: 'Your upfront payment is\u00a0processing.',
    completedTitle: 'Your upfront payment is\u00a0complete.',
    subtitle:
      "We're charging {total} to your {method} ending in {digits}. Your Belong Pros can get started while it\u00a0processes.",
    completedSubtitle:
      'We charged {total} to your {method} ending in {digits}. Your Belong Pros can get\u00a0started.',
    unconfirmedSubtitle:
      "We're charging {total} to your {method} ending in {digits}. We'll confirm your report as soon as the payment goes\u00a0through.",
    howItWorks: 'How It Works',
    upfrontTitle: 'Upfront Payment · {total}',
    upfrontDetail: '{amount} (20% Upfront)',
    upfrontDetailWithFee: `{amount} (20% Upfront) plus ${PAYMENTS_FEE_CONST.CREDIT_CARD_FEE} card\u00a0fee.`,
    upfrontStatus: 'Processing',
    upfrontCompletedStatus: 'Completed',
    inProgressTitle: 'Improvements In Progress',
    inProgressDetail:
      'As each task is completed, we charge you for that task and send you a\u00a0receipt.',
    inProgressStatus: 'Up Next',
    completeTitle: 'All Work Complete',
    completeDetail: 'Your task charges add up to\u00a0{remaining}.',
    completeDetailWithFee: `Your task charges add up to {remaining}, plus the ${PAYMENTS_FEE_CONST.CREDIT_CARD_FEE} card\u00a0fee.`,
    cta: 'Done',
  },
  declinedStep: {
    badge: 'Declined',
    title: "We couldn't process your\u00a0payment.",
    subtitle:
      'Please try again. If it keeps failing, use a different payment method or contact your\u00a0bank.',
    finalSubtitle:
      'We can no longer retry this payment. Please contact support so we can get your improvements\u00a0started.',
    paymentMethodTitle: 'Payment Method',
    cta: 'Try Again',
  },
} as const;
